import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import WarningIcon from '../../../src/components/LoaderImg/Avatar.svg';
import { useSelector } from 'react-redux';

type Props = {
  close: any;
  handleDelete: any;
};

const ConfirmDeleteModal = (props: Props) => {
  const { close, handleDelete } = props;
  const deleteLaborHrsResponse = useSelector((state: any) => state.deleteLaborHoursReducer);

  return (
    <Box p={3}>
      <>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <Box p={1}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  marginRight: '12px',
                }}
              >
                <img
                  alt=""
                  src={WarningIcon}
                />
              </div>
            </Box>
            <Box>
              <Typography
                variant="h6"
                mt={1.8}
              >
                Are you sure you want to delete this entry?
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            sx={{ color: '#111927' }}
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            variant="contained"
            sx={{
              background: '#F04438',
              color: '#fff',
              '&:hover': {
                background: '#F04438',
              },
            }}
            onClick={handleDelete}
            disabled={deleteLaborHrsResponse.loading}
          >
            Delete
          </Button>
        </DialogActions>
      </>
    </Box>
  );
};

export default ConfirmDeleteModal;
